import React from 'react';

export interface NavProps extends React.HTMLAttributes<HTMLUListElement> {
  className?: string;
  children: React.ReactNode;
  tabs?: boolean;
  justified?: boolean;
}

export interface NavItemProps extends React.HTMLAttributes<HTMLLIElement> {
  className?: string;
  children: React.ReactNode;
  active?: boolean;
}

export interface NavLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  className?: string;
  children: React.ReactNode;
  active?: boolean;
  disabled?: boolean;
  href?: string;
  onClick?: () => void;
}

export const Nav: React.FC<NavProps> = ({ className = '', children, tabs = false, justified = false, ...props }) => {
  const navClasses = [
    'flex',
    tabs
      ? 'flex-row flex-nowrap space-x-4 overflow-x-auto border-b border-[var(--color-gray-300)]'
      : 'flex-col gap-y-2 md:flex-row md:gap-y-0',
    justified ? '[&>.nav-item]:flex-1 [&>.nav-item]:text-center' : ''
  ].filter(Boolean).join(' ');

  return (
    <ul className={`nav ${navClasses} ${className || ''}`} {...props}>
      {children}
    </ul>
  );
};

export const NavItem: React.FC<NavItemProps> = ({ className = '', children, active = false, ...props }) => {
  const itemClasses = active ? 'text-[var(--color-primary)] font-medium' : 'text-[var(--color-gray-700)] hover:text-[var(--color-primary)]';

  return (
    <li className={`nav-item ${itemClasses} ${className || ''}`} {...props}>
      {children}
    </li>
  );
};

export const NavLink: React.FC<NavLinkProps> = ({
  className = '',
  children,
  active = false,
  disabled = false,
  href = '#',
  onClick,
  ...props
}) => {
  const linkClasses = [
    active ? 'text-[var(--color-primary)] border-b-2 border-[var(--color-primary)]' : 'text-[var(--color-gray-600)] hover:text-[var(--color-primary)]',
    disabled ? 'opacity-50 cursor-not-allowed' : ''
  ].filter(Boolean).join(' ');

  return (
      <a
        href={href}
        aria-disabled={disabled || undefined}
        className={`nav-link block px-3 py-2 ${linkClasses} ${className || ''}`}
        onClick={onClick}
        {...props}
      >

      {children}
    </a>
  );
};
